import { createSelector } from 'reselect';
import { statComparisonSelector } from './simple-selectors';

export const statComparisonNavSelector = createSelector(
    statComparisonSelector,
    (statComparison) => statComparison.nav
);
